import apiClient from "services/apiClient";

async function updateManagerRole(programId: number, personId: number, body: any) {
    const res = await apiClient.put(`/admin/programs/${programId}/manager/${personId}`, body);
    return res.data;
}

export default updateManagerRole;
